module.exports = __webpack_public_path__ + "ffa10bd247f0760ecfe5b2d0a7c24891.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/paint-palette-s.png
// module id = 2082
// module chunks = 0